(() => {
  const initProtocolSteps = () => {
    const steps = document.querySelectorAll("[data-protocol-step]");

    steps.forEach((step, index) => {
      const button = step.querySelector(".step__expand");
      const content = step.querySelector(".step__content p");

      if (!button || !content) return;

      const iconElement = button.querySelector(".icon-plus");
      if (!iconElement) {
        console.warn("No .icon-plus element found in step", index);
        return;
      }

      const plusIcon = iconElement.innerHTML;
      const minusIcon =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

      step.setAttribute("aria-expanded", "false");
      content.style.maxHeight = "0";
      content.style.paddingTop = "0";
      content.style.marginTop = "0";
      iconElement.innerHTML = plusIcon;

      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      const toggleStep = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = step.getAttribute("aria-expanded") === "true";

        step.setAttribute("aria-expanded", !isExpanded);
        newButton.setAttribute("aria-label", isExpanded ? "Expand step details" : "Collapse step details");

        const newIconElement = newButton.querySelector(".icon-plus");
        if (newIconElement) {
          if (isExpanded) {
            newIconElement.innerHTML = plusIcon;
          } else {
            newIconElement.innerHTML = minusIcon;
          }
        }

        if (isExpanded) {
          content.style.maxHeight = "0";
          content.style.paddingTop = "0";
          content.style.marginTop = "0";
          step.classList.remove("is-expanded");
        } else {
          // Calculate title width and set CSS variable
          const title = step.querySelector(".step__content h4");
          if (title) {
            const titleWidth = title.offsetWidth;
            content.style.setProperty("--title-width", `${titleWidth}px`);
          }

          content.style.maxHeight = `${content.scrollHeight + 20}px`;
          content.style.paddingTop = "16px";
          content.style.marginTop = "16px";
          step.classList.add("is-expanded");
        }
      };

      step.addEventListener("click", toggleStep);
      newButton.addEventListener("click", toggleStep);
    });
  };

  const initWithRetry = () => {
    initProtocolSteps();

    setTimeout(() => {
      initProtocolSteps();
    }, 100);

    setTimeout(() => {
      initProtocolSteps();
    }, 1000);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWithRetry);
  } else {
    initWithRetry();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.querySelector("[data-protocol-step]")) {
      setTimeout(initProtocolSteps, 100);
    }
  });
})();
